<template>
  <div>
    <base-title title="Integrações" />

    <div class="integrations">
      <div class="type">Gestão de tráfego e Métricas (3)</div>
      <div class="grid">
        <!--         <div class="item">
          <div class="integration-img">
            <img
              src="@/assets/img/google-ads.svg"
              class="img-fluid"
              alt="Google Ads"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>Google Ads</p>
              <base-badge type="exclamation" name="Em breve" />
            </div>
            <p class="description">
              O Google Ads é a plataforma de anúncios do Google. Sua primeira
              versão foi lançada em 2000 e desde então lidera o mercado de Mídia
              Online. Através do Google Ads é possível criar anúncios de
              Pesquisa, de Display, no Youtube, no Gmail e na Play Store.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('google-ads')"
            />
          </div>
        </div> -->

        <div class="item">
          <div class="integration-img">
            <img
              src="@/assets/img/google-tag-manager.svg"
              class="img-fluid"
              alt="Google Tag Manager"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>Google Tag Manager</p>
            </div>
            <p class="description">
              O Google Tag Manager é uma ferramenta de soluções para inserir
              scripts em sites, tornando a rotina de times de marketing muito
              mais simples e produtiva. Com seus recursos, é possível monitorar
              métricas e rastrear resultados do Analytics.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('google-tag-manager')"
            />
          </div>
        </div>

        <div class="item">
          <div class="integration-img">
            <img
              src="@/assets/img/facebook.svg"
              class="img-fluid"
              alt="API de Conversões do Facebook"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>API de Conversões do Facebook</p>
            </div>
            <p class="description">
              A API de Conversões do Facebook é uma ferramenta analítica que o
              Facebook disponibiliza para ajudar a mensurar o sucesso de uma
              campanha patrocinada a partir de um código inserido em cada página
              de seu site.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('facebook-pixel')"
            />
          </div>
        </div>

        <div class="item">
          <div class="integration-img">
            <img
              src="@/assets/img/google-analytics.svg"
              class="img-fluid"
              alt="Google Analytics"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>Google Analytics</p>
              <base-badge type="exclamation" name="Em breve" />
            </div>
            <p class="description">
              Google Analytics é a ferramenta de monitoramento e análise de
              sites mais utilizados no mundo. Ela se integra com outros serviços
              do Google, como Ads e Search Console. Com ela é possível monitorar
              o perfil de quem acessa seu site, páginas mais acessadas,
              conversões, dispositivos, cidades e outros dados.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('google-analytics')"
            />
          </div>
        </div>
      </div>
      <!--
      <div class="type">Pagamento Online (1)</div>
      <div class="grid">
        <div class="item">
          <div class="integration-img">
            <img
              src="https://cdn.easydelivery.com.br/juno.png"
              class="img-fluid"
              alt="Juno"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>JUNO</p>
              <base-badge type="exclamation" name="Em breve" />
            </div>
            <p class="description">
              A Juno é uma intermediadora de pagamentos. Com esta integração,
              seu cliente poderá pagar online via cartão de crédito ou pix e
              você realiza toda a gestão e movimentação da sua conta diretamente
              no seu painel Easy Delivery.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('sobre-integracao', { name: 'juno' })"
            />
          </div>
        </div>
      </div>
      -->
      <div class="type">Logística (1)</div>
      <div class="grid">
        <div class="item">
          <div class="integration-img">
            <img
              src="@/assets/img/foody-delivery.png"
              class="img-fluid"
              alt="Foody Delivery"
            />
          </div>
          <div class="integration-info">
            <div class="name">
              <p>Foody Delivery</p>
            </div>
            <p class="description">
              Plataforma de logística urbana para estabelecimento delivery ou
              empresa de entregas. Rastreamento de entregadores, planejamento de
              rotas, distribuição automática de entregas para deixar sua
              operação logística automatizada.
            </p>
          </div>
          <div class="see-more">
            <base-button
              design="underline"
              text="VER MAIS"
              class="p_0"
              @click="changeRoute('foody-delivery-sobre')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBadge from '@/components/Badge';
import StoreAPI from '@/api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseBadge,
  },
  data() {
    return {
      integrations: {},
    };
  },
  async created() {
    const response = await StoreAPI.storeGetConfiguration();

    const configuration = response.getData([]);

    this.integrations = {
      ads: !!configuration.ads,
      analytics: !!configuration.analytics,
      tagManager: !!configuration.tagManager,
      pixel: !!configuration.pixel,
    };
  },
  methods: {
    changeRoute(routeName, params = {}) {
      const { ads, analytics, tagManager, pixel } = this.integrations;

      switch (routeName) {
        case 'google-ads':
          routeName = ads ? 'cadastro-google-ads' : routeName;
          break;

        case 'google-analytics':
          routeName = analytics ? 'cadastro-google-analytics' : routeName;
          break;

        case 'google-tag-manager':
          routeName = tagManager ? 'cadastro-google-tag-manager' : routeName;
          break;

        case 'facebook-pixel':
          routeName = pixel ? 'cadastro-facebook-pixel' : routeName;
          break;
        default:
          break;
      }

      this.$router.push({ name: routeName, params });
    },
  },
};
</script>

<style scoped>
.integrations .type {
  background: #212224;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
}
.integrations .type:not(:nth-child(1)) {
  margin-top: 35px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.grid .item {
  border-radius: 5px;
  background: var(--box);
  position: relative;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
}
.integration-img {
  background: #595959;
  border-radius: 5px;
  width: 83px;
  height: 83px;
  margin-right: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
}
.integration-img img {
  width: 60px;
  max-height: 30px;
}
.integration-info {
  flex: 1;
}
.integration-info .name {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #505050;
  height: 35px;
}
.integration-info .name p {
  font-weight: 900;
  color: var(--default);
  font-size: 1.6em;
  line-height: 19px;
  text-transform: uppercase;
}
@media screen and (min-width: 992px) and (max-width: 1300px) {
  .integration-info .name p {
    position: absolute;
    white-space: nowrap;
    max-width: 290px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
@media screen and (min-width: 1350px) and (max-width: 1400px) {
  .integration-info .name p {
    position: absolute;
    white-space: nowrap;
    max-width: 265px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.integration-info .description {
  color: #bfbfbf;
  font-size: 1.2em;
  line-height: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.see-more {
  flex: 0 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
@media screen and (max-width: 1350px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 991px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .integration-info .name p {
    font-size: 14px;
  }
}
</style>
